import { render, staticRenderFns } from "./ModalUnbanHC.vue?vue&type=template&id=42c6a6bc"
import script from "./ModalUnbanHC.vue?vue&type=script&lang=js"
export * from "./ModalUnbanHC.vue?vue&type=script&lang=js"
import style0 from "./ModalUnbanHC.vue?vue&type=style&index=0&id=42c6a6bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports